import Image from "components/common/images/Image";
import { CandidateItemModel } from "models";
import React, { ChangeEvent } from "react";
import { MdOutlineCancel } from "react-icons/md";
import { Utils } from "utils";

type PROPS = {
  item: CandidateItemModel;
  update: () => void;
  onDelete: (target: CandidateItemModel) => void;
};

const CandidateItemListItemElement: React.FC<PROPS> = (props) => {
  const item = props.item;

  const [quantity, setQuantity] = React.useState<number | "">(item.quantity);

  React.useEffect(() => {
    setQuantity(item.quantity);
  }, [item.quantity])

  const onChangeQuantity = (e: ChangeEvent<HTMLInputElement>) => {
    const value = (e.target as any).value;
    const numericValue = value; 
    const sanitizedValue = numericValue.replace(/^0+/, "");
    setQuantity(sanitizedValue !== "" ? sanitizedValue : "0");
  };
  
  const onBlur = (e: ChangeEvent<HTMLInputElement>) => {
    const numericValue = quantity === "" ? "0" : quantity.toString();
    const sanitizedNumericValue = numericValue.replace(/^0+/, "0");
    const sanitizedNumericValues = sanitizedNumericValue.replace(/\D/g, "");
    item.quantity = sanitizedNumericValues as any;
    setQuantity(item.quantity as any); 
    props.update();
  };
  const onDelete = () => {
    props.onDelete(props.item);
  };

  const updateQuantity = (type: 'increase' | 'decrease') => {
    let tempQuantity = 0
    if(type === 'increase') {
      if(+quantity >= 9999) return;
      tempQuantity = +quantity + 1;
    } else {
      if(+quantity < 1) return;
      tempQuantity = +quantity - 1;
    }

    item.quantity = tempQuantity;
    setQuantity(tempQuantity);
    props.update();
  };

  return (
    <tr className="border-b border-b-gray-400">
      <td className="p-2">
        {/* <Link to={`/item-detail/${item.candidate_item_cd}/`}> */}
        <Image maxHeight="150px" data={item.item_main_image} default="item.png" />
        {/* </Link> */}
      </td>
      <td>{item.item_name}</td>
      <td className="text-center">
        <div className="flex items-center justify-center border border-black rounded-lg w-fit mx-auto">
          <button
            className={`px-4 py-2 text-xl ${quantity as any <= 1 ? 'text-gray' : 'text-jhk-blue'}`}
            onClick={() => updateQuantity("decrease")}
            disabled={quantity as any <= 1}
          >
            -
          </button>
          <input type="tel" className="text-center border-none outline-0 rounded-none" value={quantity} onChange={onChangeQuantity} onBlur={onBlur}  />
          <button
            className={`px-4 py-2 text-xl ${quantity as any >= 9999 ? 'text-gray ' : 'text-jhk-blue '}`}
            onClick={() => updateQuantity("increase")}
            disabled={quantity as any >= 9999}
          >
            +
          </button>
        </div>
      </td>
      {item.is_discretionary_price ? (
        <td className="text-center">-</td>
      ) : (
        <td className="text-center">
          <span className="font-bold">{Utils.addComma(item.sale_price)}</span>
          <span>円(税抜)</span>
        </td>
      )}
      <td>
        <button onClick={onDelete}>
          <MdOutlineCancel className="text-2xl" />
        </button>
      </td>
    </tr>
  );
};

export default CandidateItemListItemElement;
